"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
ProductSearchDirective.$inject = ['$location', '$rootScope'];
function ProductSearchDirective($location, $rootScope) {
    return {
        restrict: 'E',
        template: require('./views/search-directive.html'),
        scope: true,
        link: function (scope, elem, attrs) {
            scope.searchText = null;
            scope.searching = false;
            scope.trigger = function (ev) {
                if (ev.keyCode && ev.keyCode === 13) {
                    scope.search();
                }
            };
            scope.search = function () {
                $location.path('/search').search('q', scope.searchText);
            };
            scope.$on('$locationChangeStart', function ($event, next, current) {
                if (next.indexOf('/search') === -1) {
                    scope.searchText = null;
                }
            });
        }
    };
}
exports.ProductSearchDirective = ProductSearchDirective;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/search/directives/ProductSearchDirective.js
// module id = 474
// module chunks = 0